import { AngularMaterialModule } from 'apps/wsg/src/app/angular-material.module';
import { PeriodService } from './period.service';
import { PeriodsComponent } from './periods.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [ CommonModule, AngularMaterialModule, ReactiveFormsModule ],
  declarations: [ PeriodsComponent ],
  exports: [ PeriodsComponent ],
  providers: [ PeriodService ]
})
export class PeriodsModule { }
